import React, { useState } from "react";
import { Box, Tabs, Tab } from "@mui/material";
import DashboardTaskList from "./CalendarLinearView";
import CalendarComponent from "./CalendarComponent";

const TaskCalendarView = () => {
  const [view, setView] = useState("calendar");
  const [linearBooted, setLinearBooted] = useState(false); // fire once when first opened

  const handleTabChange = (_e, newValue) => {
    setView(newValue);
    if (newValue === "linear" && !linearBooted) setLinearBooted(true);
  };

  return (
    <Box sx={{ padding: 2, textAlign: "center" }}>
      <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
        <Tabs
          value={view}
          onChange={handleTabChange}
          TabIndicatorProps={{ style: { display: "none" } }}
          sx={{
            backgroundColor: "#F0F0F0",
            borderRadius: "25px",
            padding: "6px",
            width: "fit-content",
            minHeight: "50px",
            "& .MuiTabs-flexContainer": { gap: "10px" },
          }}
        >
          <Tab
            label="📅 Calendar View"
            value="calendar"
          />
          <Tab
            label="📋 Linear View"
            value="linear"
          />
        </Tabs>
      </Box>

      <Box sx={{ mt: 1.7 }}>
        {view === "calendar" ? (
          <CalendarComponent />
        ) : (
          // render only after first open, pass trigger prop
          linearBooted && <DashboardTaskList triggerFetch />
        )}
      </Box>
    </Box>
  );
};

export default TaskCalendarView;
